export const AUTH_REQUEST_TIMEOUT_MS = 15000
export const AUTH_REQUEST_TIMEOUT_MESSAGE = 'Authentication service request timed out.'

const abortError = () => Object.assign(new Error('Authentication request aborted.'), { name: 'AbortError' })

// Only Auth traffic gets this deadline. Data, Storage and Edge requests keep
// their existing cancellation and timeout behavior.
export function createAuthTimeoutFetch(fetchRequest, authBaseUrl, { timeoutMs = AUTH_REQUEST_TIMEOUT_MS } = {}) {
  const authBase = new URL(authBaseUrl)
  return (input, init) => {
    let target
    try { target = new URL(typeof input === 'string' || input instanceof URL ? input : input.url) } catch { return fetchRequest(input, init) }
    if (target.origin !== authBase.origin || !target.pathname.startsWith(authBase.pathname)) return fetchRequest(input, init)
    const callerSignal = init?.signal || (typeof input === 'object' ? input.signal : undefined)
    const controller = new AbortController()
    return new Promise((resolve, reject) => {
      let complete = false
      const cleanup = () => { clearTimeout(timer); callerSignal?.removeEventListener('abort', cancel) }
      const finish = (callback, value) => { if (complete) return; complete = true; cleanup(); callback(value) }
      const cancel = () => {
        const error = callerSignal?.reason || abortError()
        finish(reject, error)
        controller.abort(error)
      }
      const timer = setTimeout(() => {
        const error = Object.assign(new Error(AUTH_REQUEST_TIMEOUT_MESSAGE), {name:'AuthRequestTimeoutError',code:'AUTH_REQUEST_TIMEOUT'})
        finish(reject, error)
        controller.abort(error)
      }, timeoutMs)
      callerSignal?.addEventListener('abort', cancel, {once:true})
      if (callerSignal?.aborted) {cancel();return}
      Promise.resolve().then(() => {
        if (controller.signal.aborted) throw controller.signal.reason || abortError()
        return fetchRequest(input, {...init,signal:controller.signal})
      }).then(async response => {
        // fetch resolves at headers. Drain a clone so a stalled JSON body is
        // covered too, while returning the original Response unchanged.
        if (typeof response?.clone === 'function') await response.clone().arrayBuffer()
        return response
      }).then(response => finish(resolve,response), error => finish(reject,error))
    })
  }
}
